import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const AuthenticatedFooter = () => {
  return (
    <footer className="bg-midnight-green/95 border-t border-deep-teal mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Homepage Link */}
          <div>
            <Button asChild variant="ghost" className="text-sand hover:text-copper">
              <Link to="/" className="flex items-center gap-2">
                <Home className="h-4 w-4" />
                <span>Main Site</span>
              </Link>
            </Button>
          </div>

          {/* Quick Links */}
          <div className="flex items-center gap-4 text-sm text-sand/70">
            <Link to="/support" className="hover:text-copper transition-colors">
              Support
            </Link>
            <span className="text-sand/40">•</span>
            <Link to="/contact" className="hover:text-copper transition-colors">
              Contact
            </Link>
            <span className="text-sand/40">•</span>
            <Link to="/privacy" className="hover:text-copper transition-colors">
              Privacy
            </Link>
            <span className="text-sand/40">•</span>
            <Link to="/terms" className="hover:text-copper transition-colors">
              Terms
            </Link>
            <span className="text-sand/40">•</span>
            <span>© {new Date().getFullYear()} All rights reserved</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
